import { apiClient } from '~/api/client';
import { AgentJSONAPI } from '~/api/resources/agent';

type ShowParams = {
  id: string;
  period?: Period;
};

type Response = {
  data: AgentJSONAPI;
  error?: string;
};

export const show = async ({ id, period }: ShowParams) =>
  apiClient.get<Response>(`/realtors/${id}`, { params: { period: period } });
